import * as React from "react";
import PropTypes from "prop-types";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

// function CircularProgressWithLabel(props) {
//   return (
//     <Box sx={{ position: "relative", display: "inline-flex" }}>
//       <CircularProgress variant="determinate" {...props} />
//       <Box
//         sx={{
//           top: 0,
//           left: 0,
//           bottom: 0,
//           right: 0,
//           position: "absolute",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//         }}
//       >
//         <Typography variant="caption" component="div" color="text.secondary">
//         {!isNaN(props.value) && `${Math.round(props.value)}%`}
//           {/* {props.value.length > 0 && `${Math.round(props.value)}%`} */}
//         </Typography>
//       </Box>
//     </Box>
//   );
// }

function CircularProgressWithLabel(props) {
  const { value } = props;
  const [status, setStatus] = React.useState(value);
  // const parsedBatchStatus = parseFloat(value, 10);
  React.useEffect(() => {
    if (value) {
      setStatus(parseFloat(value, 10));
    }
  }, [value]);

  return (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      <CircularProgress variant="determinate" {...props} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="caption" component="div" color="text.secondary">
          {/* {!isNaN(props.value) && `${Math.round(props.value)}%`} */}{" "}
          {!isNaN(status) && `${Math.round(status)}%`}
        </Typography>
      </Box>
    </Box>
  );
}

CircularProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: PropTypes.number.isRequired,
};

export default function CircularWithValueLabel(props) {
  const { value } = props;
  const [status, setStatus] = React.useState(value);
  React.useEffect(() => {
    if (value) {
      setStatus(parseFloat(value, 10));
    }
  }, [value]);

  //   const [progress, setProgress] = React.useState(props.value);

  return <CircularProgressWithLabel value={status} />;
}
